module.exports = __webpack_public_path__ + "img/page-left.2491cfea.svg";